$.modal = {};

$.modal.pages = [
    { 'name' : 'transforming-communities', 'title' : 'Transforming Communities' },
    { 'name' : 'financials', 'title' : 'Financials' },
    { 'name' : 'student-stats', 'title' : 'Student Stats' },
    { 'name' : 'career-path', 'title' : 'Career Path' },
    { 'name' : 'research-excellence', 'title' : 'Research Excellence' },
    { 'name' : 'donor-giving', 'title' : 'Highlights of Donor Giving' },
    { 'name' : 'alumni-stats', 'title' : 'Alumni Stats' }
];

$.modal.active_page = false;

// find

$.modal.find_page = function(page_name,strict) {
    page_name = page_name || $.modal.pages[0].name;
    strict = strict || false;
    for (var i = 0; i < $.modal.pages.length; i++) {
        var page = $.modal.pages[i];
        if (page.name == page_name) {
            return page;
        }
    }
    return (strict) ? false : $.modal.pages[0];
};

// load

$.modal.load_page = function(page_name) {
    var page = $.modal.find_page(page_name);
    page_name = page.name;
    $.modal.active_page = page_name;
    // load banner
    var imgSrc = 'assets/img/modal/banner-'+ page_name +'.jpg';
    $('#modal-banner-container, #modal-banner').data('imgSrc', imgSrc);
    console.log($.img_responsive_src(imgSrc));
    var img = new Image;
    img.onload = function() {
        var imgSrc = this.src;
        $('#modal-banner').css('opacity', 0);
        $('#modal-banner').css('background-image', 'url('+ imgSrc +')');
        $('#modal-banner').removeClass().addClass(page_name).addClass('img-loaded');
        $('#modal-banner').stop(true);
        $('#modal-banner').animate({ opacity: 1 }, 400, function() {
            $('#modal-banner-container').css('background-image', 'url('+ imgSrc +')');
            $('#modal-banner-container').removeClass().addClass(page_name).addClass('img-loaded');
        });
    }
    img.src = $.img_responsive_src(imgSrc);
    // load content
    $('#modal-content').load('modal/'+ page_name +'.htm #content', function() {
        $('#modal-content').removeClass().addClass(page_name);
    });
    // make active
    $('#sidebar-menu a, #modal-menu a').removeClass('active');
    $('#sidebar-menu, #modal-menu').find('[data-page="'+ page_name +'"]').addClass('active');
};

// menu

$.modal.page_list_init = function(page_name) {
    var page = $.modal.find_page(page_name);
    page_name = page.name;
    var str = '';
    str += '<ul>';
        for (var i = 0; i < $.modal.pages.length; i++) {
            var link = $.modal.pages[i];
            var active = (link.name == page_name) ? ' class="active"' : '';
            str += '<li><a href="#'+ link.name +'" data-page="'+ link.name +'"'+ active +'>'+ link.title +'</a></li>';
        }
    str += '</ul>';
    $('#modal-sidebar').html('<div id="sidebar-menu">'+ str +'</div>');
    $('#modal-menu').html(str);
    $('#sidebar-menu a, #modal-menu a').on('click', function(e) {
        e.preventDefault();
        var page_name = $(this).data('page');
        if ($.modal.active_page != page_name) {
            $.modal.load_page(page_name);
        }
    });
};

// modal

$.modal.close_init = function() {
    $('#modal-close').on('click', function(e) {
        e.preventDefault();
        $('body').removeClass('modal-open').removeClass('modal-menu-active');
        $('#modal-banner-container, #modal-banner').css('background-image', 'none');
        $('#modal-content').empty();
    });
};

// modal menu

$.modal.menu_toggle = function() {
    if ($('body').hasClass('modal-menu-active')) {
        $('body').removeClass('modal-menu-active');
    } else {
        $('body').addClass('modal-menu-active');
    }
};

$.modal.menu_init = function() {
    $('#modal-menu-overlay').css('height', $.windowHeight);
    $('#modal-menu-btn').on('click', function(e) {
        e.preventDefault();
        $.modal.menu_toggle();
    });
    $('#modal-menu-container').on('click', 'a', function() {
        $.modal.menu_toggle();
    });
};

// facts_and_figures_btn

$.modal.facts_and_figures_btn_init = function() {
    $('.facts-and-figures-btn').on('click', function(e) {
        e.preventDefault();
        $('body').addClass('modal-open');
        var page_name = $(this).data('page');
        $.modal.load_page(page_name);
        $.modal.page_list_init(page_name);
    });
};

// hash

$.modal.hash_init = function() {
    var hash = window.location.hash;
    if (hash) {
        hash = window.location.hash.substring(1);
        var page_name = false;
        if ($.modal.find_page(hash,true)) { // page found
            page_name = hash;
        } else if (hash == 'facts-and-figures') {
            page_name = $.modal.pages[0].name;
        }
        if (page_name) { // load page
            $('body').addClass('modal-open');
            $.modal.load_page(page_name);
            $.modal.page_list_init(page_name);
        } // end load page
    }
};

$(function() {
    $.modal.close_init();
    $.modal.menu_init();
    $.modal.facts_and_figures_btn_init();
    $.modal.hash_init();
});